(() => {
  if (window.__lioraVariantGallerySyncLoaded) return;
  window.__lioraVariantGallerySyncLoaded = true;

  const fallbackFileByColor = {
    '6': 'https://cdn.shopify.com/s/files/1/0885/6846/3674/files/Dark-Brown.jpg',
    '17/101R8': 'https://cdn.shopify.com/s/files/1/0885/6846/3674/files/Vanilla-Latte.jpg',
    '22/16R8': 'https://cdn.shopify.com/s/files/1/0885/6846/3674/files/Blondie.jpg',
    'Golden Auburn': 'https://cdn.shopify.com/s/files/1/0885/6846/3674/files/Golden-Auburn.jpg',
    'Strawberry Syrup FS27': 'jr-strawberry-syrup.jpg',
    'Palm Springs Blonde FS17/101S18': 'jr-palm-springs-blonde.jpg',
    'Toffee Truffle FS6/30/27': 'jr-toffee-truffle.jpg',
    'Laguna Blonde FS24/102S12': 'jr-laguna-blonde.jpg',
    'Midnight Cocoa FS4/33/30A': 'jr-midnight-cocoa.jpg',
    'Chocolate Cherry FS2V/31V': 'jr-chocolate-cherry.jpg',
    'Pralines n\' Cream 14/26': 'jr-pralines-n-cream.jpg',
    'Shaded Pralines n\' Cream 14/26S10': 'jr-shaded-pralines-n-cream.jpg',
    'Natural Dark Brown 4RN': 'https://cdn.shopify.com/s/files/1/0880/5885/5701/files/13812.preview.jpg?v=1785319236',
    'Vanilla Macaron 14/88H': 'https://cdn11.bigcommerce.com/s-h7gb7ur4o0/images/stencil/original/attribute_value_images/15208.preview.jpg?t=1786117096',
    'Shaded Lemon Macaron 613/102S8': 'https://cdn11.bigcommerce.com/s-h7gb7ur4o0/images/stencil/original/attribute_value_images/15231.preview.jpg?t=1786117096',
    'Billionaire Blond': 'ac-billionaire-blond.jpg',
    'Buttercream Blond-R': 'ac-buttercream-blond-r.jpg',
    'Cherry Merlot': 'https://cdn.shopify.com/s/files/1/0880/5885/5701/files/Cherry_20Merlot.jpg?v=1785332028',
    'Silver Brown-MR': 'https://cdn.shopify.com/s/files/1/0880/5885/5701/files/Silver_20Brown-MR.jpg?v=1785332028',
    'Salt & Pepper-MR': 'https://reneofparis.com/wp-content/themes/astra-child/images/color_swatches/Salt%20%26%20Pepper-MR.jpg',
    'Silver Frost': 'https://reneofparis.com/wp-content/themes/astra-child/images/color_swatches/Silver%20Frost.jpg',
    'Iced Lavender Latte': 'https://cdn.shopify.com/s/files/1/0740/9077/4817/files/Iced_Lavender_Latte_480x480.jpg?v=1695156713',
    'Sangria': 'https://cdn.shopify.com/s/files/1/0740/9077/4817/files/Sangria_480x480.jpg?v=1695160808',
    'Purple Rain': 'https://cdn.shopify.com/s/files/1/0880/5885/5701/files/Purple_Rain_1.jpg?v=1783554415',
    '60': 'https://cdn.shopify.com/s/files/1/0880/5885/5701/files/60_a3fc00e4-2520-4465-955f-13d756beff51.jpg?v=1785332036',
    'Brown Sable': 'https://reneofparis.com/wp-content/themes/astra-child/images/color_swatches/Brown%20Sable.jpg',
    'Champagne Silver': 'https://reneofparis.com/wp-content/themes/astra-child/images/color_swatches/Champagne%20Silver.jpg',
    'Icy Caviar': 'https://reneofparis.com/wp-content/themes/astra-child/images/color_swatches/Icy%20Caviar.jpg',
    'Melted Cinnamon': 'https://reneofparis.com/wp-content/themes/astra-child/images/color_swatches/Melted%20Cinnamon.jpg',
    'Platinum Pearl': 'https://reneofparis.com/wp-content/themes/astra-child/images/color_swatches/Platinum%20Pearl.jpg',
    'Sugar Cane-R': 'https://reneofparis.com/wp-content/themes/astra-child/images/color_swatches/Sugar%20Cane-R.jpg',
    'RL119 Silver & Smoke': 'asset:lcc-raquel-welch-tru2life-and-featherlite-rl119.jpg',
    'RL511 Sugar & Charcoal': 'asset:lcc-raquel-welch-tru2life-and-featherlite-rl511.jpg',
    'GF119 Silver & Smoke': 'asset:lcc-gabor-designer-series-tru2life-gf119.jpg',
    'GF511 Sugar & Charcoal': 'asset:lcc-gabor-designer-series-tru2life-gf511.jpg',
    'GL44/66SS Sugared Nickel': 'asset:lcc-gabor-luminous-soft-shades-gl44-66ss.jpg',
  };

  const scriptAssetBase = [...document.scripts]
    .map((script) => script.src || '')
    .find((src) => src.includes('/liora-variant-gallery-sync.js'))
    ?.replace(/liora-variant-gallery-sync\.js(?:\?.*)?$/, '') || '';

  const mediaIdFromVariant = (variant) =>
    variant?.featured_media?.id || variant?.featured_image?.id;

  const sectionIdFromPicker = (picker) => {
    const input = picker?.closest('[id^="shopify-section-"]')
      ?.querySelector('input[id^="update-variant-"]');
    return input?.id.replace('update-variant-', '') || '';
  };

  const isTressAllurePicker = (picker) =>
    Boolean(picker?.querySelector('.liora-tressallure-variants'));

  const clickThumbnail = (thumbnail) => {
    const trigger = thumbnail?.matches('button, a, [role="button"]')
      ? thumbnail
      : thumbnail?.querySelector('button, a, [role="button"]');

    (trigger || thumbnail)?.click();
  };

  const normalizeColor = (value) => String(value || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

  const clearVirtualSwatch = () => {
    document.querySelectorAll('[data-liora-virtual-swatch]').forEach((image) => image.remove());
  };

  const fullSizeSwatchUrl = (url) => String(url || '')
    .replace(/_(?:pico|icon|thumb|small|compact|medium|large|grande|master|\d+x\d+)(?=\.(?:avif|gif|jpe?g|png|webp))/i, '')
    .replace(/([?&])width=\d+(&|$)/, '$1')
    .replace(/[?&]$/, '');

  const swatchUrlFromLabel = (label, color) => {
    const background = label
      ? window.getComputedStyle(label, '::before').backgroundImage
      : '';
    const match = background?.match(/^url\(["']?(.*?)["']?\)$/i);
    if (match?.[1]) return fullSizeSwatchUrl(match[1]);

    const fallbackFile = fallbackFileByColor[color];
    if (/^https?:\/\//i.test(fallbackFile || '')) return fallbackFile;
    if (fallbackFile?.startsWith('asset:')) {
      return scriptAssetBase + encodeURIComponent(fallbackFile.slice(6));
    }
    return fallbackFile
      ? window.location.origin + '/cdn/shop/files/' + encodeURIComponent(fallbackFile)
      : '';
  };

  const selectedColor = (picker) => {
    const input = picker?.querySelector('input[type="radio"]:checked');
    return {
      input,
      color: input?.value || '',
      label: input?.id
        ? document.querySelector(`label[for="${CSS.escape(input.id)}"]`)
        : null,
    };
  };

  const variantMediaMatchesColor = (variant, color) => {
    const media = variant?.featured_media || variant?.featured_image;
    const alt = media?.alt || media?.altText || '';
    if (!mediaIdFromVariant(variant)) return false;
    if (/swatch|colo(?:u)?r/i.test(alt)) return true;

    const normalizedAlt = normalizeColor(alt);
    const normalizedColor = normalizeColor(color);
    return Boolean(normalizedAlt && normalizedColor && normalizedAlt.includes(normalizedColor));
  };

  const showVirtualSwatch = (picker, selection = selectedColor(picker)) => {
    const { color, label } = selection;
    const url = swatchUrlFromLabel(label, color);
    if (!url) return;

    const section = picker?.closest('[id^="shopify-section-"]') || document;
    const slideCandidates = [
      ...section.querySelectorAll('.splide__slide.is-active[data-media-id], [data-media-id].is-active'),
      ...section.querySelectorAll('[data-media-id]'),
    ];
    const isVisible = (element) => {
      if (!element) return false;
      const rect = element.getBoundingClientRect();
      const style = window.getComputedStyle(element);
      return rect.width > 1 && rect.height > 1
        && style.display !== 'none'
        && style.visibility !== 'hidden';
    };
    const activeSlide = slideCandidates.find(isVisible) || slideCandidates[0];
    const frame = activeSlide?.querySelector(
      'button[aria-label="Image zoom"], [aria-label="zoom-image"], button'
    ) || activeSlide;
    if (!frame) return;

    clearVirtualSwatch();
    const image = document.createElement('img');
    image.src = url;
    image.alt = `${color} color swatch`;
    image.dataset.lioraVirtualSwatch = 'true';
    image.className = 'liora-virtual-gallery-swatch';
    image.decoding = 'async';
    frame.appendChild(image);
  };

  const showFirstModelImage = (picker, attempt = 0) => {
    const section = picker?.closest('[id^="shopify-section-"]') || document;
    const isModelImage = (image) =>
      image && !/swatch/i.test(image.alt || '');

    const thumbnailImage = [...section.querySelectorAll('[id^="x-thumbnail-"] img')]
      .find(isModelImage);
    if (thumbnailImage) {
      clearVirtualSwatch();
      clickThumbnail(thumbnailImage.closest('[id^="x-thumbnail-"]'));
      return;
    }

    const modelImage = [...section.querySelectorAll('[data-media-id] img')]
      .find(isModelImage);
    const media = modelImage?.closest('[data-media-id]');
    const mediaKey = media?.dataset.mediaId;
    const thumbnail = mediaKey
      ? document.getElementById(`x-thumbnail-${mediaKey}`)
      : null;

    if (thumbnail) {
      clearVirtualSwatch();
      clickThumbnail(thumbnail);
      return;
    }

    if (attempt < 8) {
      window.setTimeout(() => showFirstModelImage(picker, attempt + 1), 150);
    }
  };

  const showClickedColor = (picker, input, label) => {
    const color = input?.value || '';
    const normalizedColor = normalizeColor(color);
    const section = picker?.closest('[id^="shopify-section-"]') || document;
    const matchingImage = [...section.querySelectorAll('[data-media-id] img')].find((image) => {
      const normalizedAlt = normalizeColor(image.alt);
      return normalizedColor && normalizedAlt && normalizedAlt.includes(normalizedColor);
    });

    if (matchingImage) {
      clearVirtualSwatch();
      clickThumbnail(matchingImage.closest('[data-media-id]'));
      return;
    }

    showVirtualSwatch(picker, { color, label });
  };

  const syncGallery = (variant, picker, attempt = 0) => {
    const mediaId = mediaIdFromVariant(variant);
    if (!mediaId) return;

    const sectionId = sectionIdFromPicker(picker);
    if (!sectionId) return;

    const thumbnail = document.getElementById(`x-thumbnail-${sectionId}-${mediaId}`)
      || document.querySelector(`[data-media-id="${sectionId}-${mediaId}"]`);

    if (!thumbnail) {
      if (attempt < 8) {
        window.setTimeout(() => syncGallery(variant, picker, attempt + 1), 150);
      }
      return;
    }

    // After a shopper selects a color, show that variant's assigned media.
    clickThumbnail(thumbnail);
  };

  document.addEventListener('eurus:variant:change', (event) => {
    const picker = event.target?.closest?.('.x-variant-picker')
      || document.querySelector('.x-variant-picker');

    clearVirtualSwatch();

    if (isTressAllurePicker(picker)) {
      window.setTimeout(() => showFirstModelImage(picker), 180);
      return;
    }

    const variant = event.detail?.variant;
    const { color } = selectedColor(picker);

    // Run after the theme's own variant handler has finished moving the gallery.
    window.setTimeout(() => {
      if (variantMediaMatchesColor(variant, color)) {
        syncGallery(variant, picker);
        return;
      }

      // Some legacy products have a valid global color-library swatch but no
      // product-level variant media. Show that real swatch in the main gallery
      // instead of leaving the shopper on an unrelated model image.
      showVirtualSwatch(picker);
    }, 180);
  });

  // The initially selected color does not emit a variant-change event when it
  // is clicked again. Handle that deliberate click so model-first still gives
  // way to the selected color image. Never override unavailable choices.
  document.addEventListener('click', (event) => {
    const label = event.target?.closest?.('label[for]');
    if (!label) return;

    const input = document.getElementById(label.htmlFor);
    const picker = input?.closest?.('.x-variant-picker');
    if (!picker || !input.checked || input.dataset.available === 'false') return;

    if (isTressAllurePicker(picker)) {
      window.setTimeout(() => showFirstModelImage(picker), 220);
      return;
    }

    window.setTimeout(() => showClickedColor(picker, input, label), 220);
  });

  const restoreTressAllureModelImages = () => {
    document.querySelectorAll('.x-variant-picker').forEach((picker) => {
      if (isTressAllurePicker(picker)) showFirstModelImage(picker);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.setTimeout(restoreTressAllureModelImages, 260);
    }, { once: true });
  } else {
    window.setTimeout(restoreTressAllureModelImages, 260);
  }

  document.addEventListener('shopify:section:load', () => {
    window.setTimeout(restoreTressAllureModelImages, 260);
  });
})();
